<template>
    <div class="wrap-content form-registration">
        <div class="filter-section row-min-space">
            <div class="row">
                <div class="col-md-6 filter-title-section">
                    <h2 v-if="$route.meta.previewForm != true">
                        Registration Form Builder
                    </h2>
                    <h2 v-if="$route.meta.previewForm == true">Form Preview</h2>
                </div>
                <div class="col-md-6 text-right">
                    <div class="row">
                        <div class="col-md-8 text-right float-right">
                            <button
                                v-if="$route.meta.previewForm != true"
                                class="btn btn-link"
                                @click.prevent="formPreview()"
                            >
                                <span class="btn-text"
                                    >Preview Registration Form</span
                                >
                            </button>
                        </div>

                        <div
                            v-if="$route.meta.previewForm == true"
                            class="col-md-4 text-right"
                        >
                            <router-link
                                :to="{
                                    name: this.$route.params.name,
                                }"
                                class="btn btn-link go-back-btn"
                            >
                                <span>
                                    <i class="icon-caret-left"></i>
                                </span>
                                <span>Go back</span>
                            </router-link>
                        </div>

                        <div class="col-md-4 text-right">
                            <button
                                v-if="$route.meta.previewForm != true"
                                class="btn btn-primary"
                                :class="showLoader ? 'disabled' : ''"
                                @click.prevent="onSubmit()"
                            >
                                <span class="btn-text">Update Form</span>
                                <span class="loader"></span>
                            </button>
                        </div>
                        <base-toast></base-toast>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="$route.meta.previewForm != true"
            ref="listingArea"
            class="config-list"
        >
            <!-- <div v-show="listVal <= 850" class="config-list-dropdown">
                <b-form-group
                    id="input-group-5"
                    label="Form Builder"
                    label-for="form-builder"
                >
                    <b-form-select
                        id="form-builder"
                        class="form-control"
                        v-model="menuListingChanges"
                        :options="menuListing"
                        v-on:change="onChange"
                    >
                    </b-form-select>
                </b-form-group>
            </div> -->
            <ul>
                <li v-for="(list, index) in menuListing" :key="index">
                    <a
                        v-if="changeDetect == true"
                        :class="
                            $route.meta.formBuilder == list.route
                                ? 'router-link-exact-active'
                                : ''
                        "
                        @click.prevent="
                            listing = list
                            $bvModal.show('switch-tab-popup')
                        "
                    >
                        <span>{{ list.text }}</span></a
                    >

                    <a
                        v-if="changeDetect == false"
                        :class="
                            $route.meta.formBuilder == list.route
                                ? 'router-link-exact-active'
                                : ''
                        "
                        @click.prevent="
                            listing = list
                            onChangeTab(false)
                        "
                    >
                        <span>{{ list.text }}</span></a
                    >
                </li>
            </ul>
        </div>

        <div class="form-builder-area">
            <router-view />
        </div>

        <switch-tab-popup @tab-switch="onChangeTab"></switch-tab-popup>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SwitchTabPopup from '@/components/popups/form-builder/SwitchTabPopup.vue'

const apiUrl = process.env.VUE_APP_API_URL
import axios from 'axios'
const headers = {
    headers: {
        Authorization: `Bearer ${localStorage.getItem('vueauth_token')}`,
    },
}

export default {
    components: { SwitchTabPopup },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            showLoader: false,
            previewForm: false,
            menuListingChanges: '/configuration/form-builder',
            listVal: null,
            menuListing: [
                {
                    value: '/configuration/form-builder',
                    text: 'Setup Profile',
                    route: 'setup-profile',
                },
                {
                    value: '/configuration/form-builder/account-info',
                    text: 'Account Info',
                    route: 'account-info',
                },
            ],
            listing: {},
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'formBuilderData',
            'loading',
            'success',
            'changeDetect',
        ]),
    }, // End of Component > mounted

    watch: {
        changeDetect() {},
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        //this.listWidthVal()
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        // listWidthVal() {
        //     this.listVal = this.$refs.listingArea.offsetWidth
        // },
        // tableItemLength(val) {
        //     this.tableItemData = val
        // },
        // close() {
        //     this.listDropdown = false
        // },
        // tabFilter(index) {
        //     this.tabData = index
        // },
        onChange() {
            this.$router.push('' + this.menuListingChanges + '')
        },
        onChangeTab(value) {
            if (this.changeDetect) {
                if (value) {
                    this.previewForm = false
                    this.$store.commit('setChangeDetect', false)
                    this.$router.push(this.listing.value)
                }
            } else {
                this.previewForm = false
                this.$router.push(this.listing.value)
            }
        },
        formPreview() {
            this.previewForm = true
            this.$router.push({
                name: 'preview_form',
                params: {
                    name: this.$route.name,
                },
            })
        },

        async onSubmit() {
            if (this.formBuilderData.fields.length > 0) {
                try {
                    this.showLoader = true
                    let { data } = await axios.put(
                        apiUrl + 'form-builder/',
                        this.formBuilderData,
                        headers
                    )
                    this.$store.commit('setSuccess', data.message)
                    this.showLoader = false
                    this.previewForm = false
                    this.$store.commit('setChangeDetect', false)
                } catch (errors) {
                    this.showLoader = false
                    this.$store.commit('setError', errors)
                }
            }
        }, // End of onSubmit() method
    },
    // End of Component > watch
} // End of export default
</script>
